var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobAppliedCountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "briefcase_6196660",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 17.998,
    viewBox: "0 0 17.998 17.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39885",
    "data-name": "Path 39885",
    d: "M1.844,235.9A2.886,2.886,0,0,1,0,235.236v5.855H10.282A4.4,4.4,0,0,1,18,238.763v-3.527a2.886,2.886,0,0,1-1.844.664Z",
    transform: "translate(0 -226.967)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39886",
    "data-name": "Path 39886",
    d: "M221.649,175.418a1.253,1.253,0,0,0-1.252,1.252v.461h2.5v-.461A1.253,1.253,0,0,0,221.649,175.418Z",
    transform: "translate(-212.65 -169.251)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39887",
    "data-name": "Path 39887",
    d: "M13.218,2.372V0H4.781V2.372H0V6.034A1.847,1.847,0,0,0,1.844,7.879H6.693V7.418a2.306,2.306,0,1,1,4.612,0v.461h4.849A1.847,1.847,0,0,0,18,6.034V2.372Zm-7.382,0V1.055h6.328V2.372Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39888",
    "data-name": "Path 39888",
    d: "M324.947,321.6a3.347,3.347,0,1,0,3.347,3.347A3.351,3.351,0,0,0,324.947,321.6Zm-.279,4.828-1.659-1.659.746-.746.913.913,1.472-1.472.746.746Z",
    transform: "translate(-310.295 -310.295)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobAppliedCountIcon);
export default __webpack_public_path__ + "static/media/job_applied_Count_Icon.650d47dad752c56fd4060d3cdfac613b.svg";
export { ForwardRef as ReactComponent };